<template>
  <form>
    <div class="container ">

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <h5 style="font-size: large;">{{$tr('mobileWelcomeScreen.have.account','Already have an account')}}</h5>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <button
              type="button"
              class="btn btn-primary col-12 font-weight-bold"
              data-test-path="signin-btn-signin"
              style="padding: 10px 0 "
              @click="switchModeToLogin()">
            Log In</button>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <h5 style="font-size: large;">{{$tr('mobileWelcomeScreen.dont.have.account',"Don't have and account")}}</h5>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <button
              type="button"
              class="btn btn-primary col-12 font-weight-bold"
              data-test-path="signin-btn-signin"
              style="padding: 10px 0 "
              @click="switchModeToSignUp()">
            Sign Up</button>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <h5 style="font-size: large;">{{$tr('mobileWelcomeScreen.first.contact','It is my first contact with SilkPLM<')}}</h5>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <button
              type="button"
              class="btn btn-outline-primary col-12 font-weight-bold"
              data-test-path="signin-btn-signin"
              style="padding: 10px 0; border-width: 2px;"
              @click="openBrowser('https://silkplm.com/presentation-form/')">
            {{$tr('mobileWelcomeScreen.learn.more','Learn more')}}</button>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-12 d-flex justify-content-center">
          <button
              type="button"
              class="btn btn-outline-primary col-12 font-weight-bold"
              data-test-path="signin-btn-signin"
              style="padding: 10px 0; border-width: 2px;"
              @click="openBrowser('https://silkplm.com/')">
            {{$tr('mobileWelcomeScreen.check.website','Check our website')}}</button>
        </div>
      </div>

      <div class="row mt-3 p-0 justify-content-center image-container"
           :style = "(mobileHeight?'display:flex;'+(isMobile?'height:150px;':'height:190px;') :'display:none;')">
        <div class="col-10 d-flex justify-content-center p-0 h-100" >
          <img style="object-fit: cover; object-position: 0% 100%;" class="w-100 p-0" src="https://silkplm.com/wp-content/uploads/2023/11/mobile-head.png" alt="The top of some lady's head">
        </div>
      </div>

    </div>
  </form>
</template>

<script>

import Client from "@/utils/Client";
import Rpc from "@/Rpc";
import SessionManager from "@/utils/SessionManager";
import RpcMustWaitException from "@/server/com/silkplm/rpc/RpcMustWaitException";
import InputLock from "@/utils/InputLock";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";
import OrganizationDeletedException from "@/server/com/silkplm/rpc/exceptions/OrganizationDeletedException";
import vSwitch from "@/components/inputs/vSwitch.vue";
import EntityEditForm from "@/components/forms/EntityEditForm.vue";


export default {
  name: "MobileWelcomeScreen",

  components: {EntityEditForm},

  created() {},

  mounted() {
    window.addEventListener('resize', this.checkIsMobile);
    this.checkIsMobile();
  },

  watch: {
    'errors': {
      handler(newValue, oldValue) {
        this.hasErrors = Object.values(oldValue).some(val => val);
      },
      deep: true
    },
  },

  computed: {
    checkIsCordova() {
      return window.isCordova;
    },
  },

  methods: {

    checkIsMobile() {
      const isMobile = window.matchMedia('(max-width: 380px)').matches;
      this.isMobile = isMobile;
      const mobileHeight = window.matchMedia('(min-height: 700px)').matches;
      this.mobileHeight = mobileHeight;
    },

    switchModeToLogin() {
      this.$emit("update-welcome-mode");
    },

    switchModeToSignUp() {
      this.$emit("update-welcome-mode", "signUp");
    },

    openBrowser(url) {
      if (this.checkIsCordova) {
        const options = 'location=yes,hidden=no,clearcache=yes,clearsession=yes';

        const inAppBrowserRef = window.cordova.InAppBrowser.open(url, '_blank', options);

        inAppBrowserRef.addEventListener('loadstart', function (event) {
          console.log('Strona rozpoczęła ładowanie:', event.url);
        });

        inAppBrowserRef.addEventListener('loadstop', function (event) {
          console.log('Strona została załadowana:', event.url);
        });
      } else{
        window.open(url, '_system');
      }
    }
  },

  data: () =>({
    isMobile: null,
    mobileHeight: null
  }),

  beforeDestroy() {
    window.removeEventListener('resize', this.checkIsMobile);
  },
}
</script>

<style lang="sass" scoped>
@import '../styles/signin-signup'


.h5Line::before,
.h5Line::after
  background-color: rgba(183, 183, 183, 0.3)
  content: ""
  display: inline-block
  height: 2px
  position: relative
  vertical-align: middle
  width: 43%

.h5Line::before
  right: 0.5em
  margin-left: -55%

.h5Line::after
  left: 0.5em
  margin-right: -55%

</style>